// PdfPreview.tsx
import React, { useEffect, useRef } from 'react';
import * as pdfjsLib from 'pdfjs-dist';
//@ts-ignore
pdfjsLib.GlobalWorkerOptions.workerSrc = '/pdf.worker.js';

interface PdfPreviewProps {
  pdfUrl: string;
  width?: number;
  height?: number;
}

const PdfPreview: React.FC<PdfPreviewProps> = ({ pdfUrl, width = 300, height = 400 }) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    let isMounted = true;

    async function renderPDF() {
      if (!pdfUrl || !canvasRef.current) return;

      try {
        // 1) Load the PDF
        const loadingTask = pdfjsLib.getDocument(pdfUrl);
        const pdf = await loadingTask.promise;
        if (!isMounted) return;

        // 2) Get the first page
        const page = await pdf.getPage(1);
        if (!isMounted) return;

        // 3) Decide on scale so the page fits the desired width
        //    For simplicity, let's do a fixed scale of 1, or adjust to your preference
        const scale = 1;
        const viewport = page.getViewport({ scale });

        // 4) Prepare canvas using PDF page dimensions
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d')!;
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        // 5) Render PDF page into canvas
        await page.render({ canvasContext: ctx, viewport }).promise;
      } catch (err) {
        console.error('Error loading PDF:', err);
      }
    }

    renderPDF();

    return () => {
      // Cleanup so we don't set state if unmounted
      isMounted = false;
    };
  }, [pdfUrl]);

  // You can style the canvas or wrap it in a container to set final width/height
  return (
    <div style={{ width, height, overflow: 'hidden' }}>
      <canvas ref={canvasRef} style={{ width: '100%', height: 'auto' }} />
    </div>
  );
};

export default PdfPreview;
